import React from 'react'
import HeroSection from '../Components/HeroSection'
// import UXcasestudies from '../Components/UXcasestudies'
import Footer from '../Components/Footer'
import Navbar from '../Components/Navbar';
import MyPortfolioSection from '../Components/MyPortfolioSection';


const Home = () => {
  return (
    <div> 

    <Navbar />


    
    <HeroSection />
    {/* <UXcasestudies /> */}
    <MyPortfolioSection />
    <Footer />
    
    </div>
  ) 
}

export default Home